import { createFileRoute } from '@tanstack/react-router';
import { HrOverviewPage } from '../../../../components/portals/hr/HrOverviewPage';

export const Route = createFileRoute('/portal/managers/hr/')({
  component: HrOverviewPage,
});
